import httpClient from 'shared/lib/httpClient';

export const login = async (formData) => {
  const response = await httpClient.post('/login', formData);
  return response?.data;
};
